import { objComparatorICase } from "../utils.js";
import axios from 'axios';
import { endpoint, remoteCreate, remoteModifyPatch } from "./utils.js";

export async function fetchParks(params = {}) {
  let path = "internal/current/parks/";
  let getParams = [];
  for (const [key, value] of Object.entries(params)) {
    getParams.push(`${key}=${encodeURIComponent(value)}`);
  }
  if (getParams.length > 0) {
    path = `${path}?${getParams.join('&')}`;
  }
  const res = await axios.get(endpoint(path), {
    withCredentials: true
  });
  return res.data.sort((a, b) => objComparatorICase(a, b, 'name'));
}

export async function fetchCSs(params = {}) {
  let path = "internal/current/chargingstations/";
  let getParams = [];
  for (const [key, value] of Object.entries(params)) {
    getParams.push(`${key}=${encodeURIComponent(value)}`);
  }
  if (getParams.length > 0) {
    path = `${path}?${getParams.join('&')}`;
  }
  const res = await axios.get(endpoint(path), {
    withCredentials: true
  });
  return res.data;
}

export async function fetchParkById(id) {
  const response = await axios.get(endpoint(`internal/current/parks/${id}/`), {
    withCredentials: true
  });
  return response.data;
}

export async function fetchParkAdmins(id) {
  const response = await axios.get(
    endpoint(`internal/current/users/?parkadmin__managed_parks=${id}`),
    { withCredentials: true });
  return response.data;
}

export async function fetchCSByQR(qrcode) {
  const response = await axios.get(
    endpoint(`internal/current/chargingstations/?qrcodeid=${qrcode}`),
    { withCredentials: true });
  return response.data[0];
}

export async function resizePark(useAlerts, park_id, new_size, dry_run) {
  const payload = {
    new_size: new_size,
    dry_run: dry_run
  };
  try {
    const res = await axios.post(endpoint(`internal/current/parks/${park_id}/resize_to/`), payload, {
      withCredentials: true
    });
    if (res.status !== 200) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${res.status} ${res.data}`);
      return;
    }
    return res.data;
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${e.response.status}`, `${JSON.stringify(e.response.data)}`);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(e.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(e.message)}`);
    }
  }
}

export async function createPark(useAlerts, payload) {
  await remoteCreate(useAlerts, endpoint("internal/current/parks/"), payload, 'Park', 'Park');
}

export async function modifyPatchPark(useAlerts, payload, park_id) {
  await remoteModifyPatch(useAlerts, endpoint(`internal/current/parks/${park_id}/`), payload, 'Park', 'Park');
}

export async function modifyPatchCS(useAlerts, payload, park_id, park_bnum) {
  // TODO: reimplement wthout using useAlerts, so that we can remove the suppressAlert feature from useAlerts
  await remoteModifyPatch(useAlerts, endpoint(`internal/current/parks/${park_id}/chargingstations/${park_bnum}/`),
    payload, 'Charging Station', 'CS', 'bnum');
}

export async function startCharge(useAlerts, qrcode) {
  try {
    const res = await axios.post(
      endpoint(`public/1/chargecontroller/${qrcode}/start_charge/`),
      {}, {
        withCredentials: true
      });
    if (res.status !== 200) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${res.status} ${res.data}`);
      return;
    }
    return res.data;
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${e.response.status}`, `${JSON.stringify(e.response.data)}`);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(e.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(e.message)}`);
    }
  }
}

export async function forceCloseCharge(useAlerts, park_id, park_bnum) {
  try {
    const res = await axios.post(
      endpoint(`internal/current/parks/${park_id}/chargingstations/${park_bnum}/force_close_charge/`),
      {}, {
        withCredentials: true
      });
    if (res.status !== 200) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${res.status} ${res.data}`);
      return;
    }
    return res.data;
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${e.response.status}`, `${JSON.stringify(e.response.data)}`);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(e.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(e.message)}`);
    }
  }
}

export async function sendYearlyReport(useAlerts, park_id, start_date, email) {
  try {
    const res = await axios.post(
      endpoint(`internal/current/parks/${park_id}/send_yearly_report/`),
      {
        start: start_date,
        email: email,
      }, {
        withCredentials: true
      });
    if (res.status !== 200) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${res.status} ${res.data}`);
      return;
    }
    return res.data;
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${e.response.status}`, `${JSON.stringify(e.response.data)}`);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(e.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(e.message)}`);
    }
  }
}
